import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/content`)
      .then((res) => {
        if (mounted) setContent(res.data?.data || null);
      })
      .catch((e) => {
        if (mounted) setError(e.message);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <ContentContext.Provider value={{ content, error }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);

/** Helper to resolve image URLs — admin uploads start with /api/uploads/ which
 *  must be prefixed with REACT_APP_BACKEND_URL. Local /assets/ paths are served
 *  directly by the frontend dev server. */
export function resolveAsset(src) {
  if (!src) return src;
  if (src.startsWith("/api/uploads/")) {
    return `${process.env.REACT_APP_BACKEND_URL}${src}`;
  }
  return src;
}
